import { Component, OnInit } from '@angular/core';
import { ILoader } from "./ILoader";
import { Yii } from "libraries/interfaces/Yii";
import { LoaderType } from "libraries/component/loader/loader.component";

@Component({
    selector: 'loader-modale',
    template: `
        <card>
            <div class="card-header-content" mat-dialog-title>
                ...
            </div>
            <div class="card-body-content" mat-dialog-content>

            <loader *ngIf="loader.active" [type]="loader.type">{{loader.message}}</loader>
            </div>
        </card>`
})

export class LoaderModaleComponent {
    public loader: ILoader = {
        active: true,
        message: Yii.t('wui-shared-js', 'Chargement en cours...'),
        type: LoaderType.large,
    };
}
